<template>
    <div class="row">
        <!-- <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div class="mb-2">
                <h6 class="text-uppercase mb-0">{{ $t('osym_address_information').toUpper() }}</h6>
            </div>
        </div> -->
        <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-3">
            <b-form-group :label="$t('state')">
                {{ stateData.address_state_name ? stateData.address_state_name : '-' }}
            </b-form-group>
        </div>
        <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-3">
            <b-form-group :label="$t('city')">
                {{ stateData.address_city ? stateData.address_city : '-' }}
            </b-form-group>
        </div>
        <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-3">
            <b-form-group :label="$t('neighborhood')">
                -
            </b-form-group>
        </div>
        <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-3">
            <b-form-group :label="$t('address_2')">
                {{ stateData.address ? stateData.address : '-' }}
            </b-form-group>
        </div>
    </div>
</template>
<script>
import CityService from "@/services/CityService";

export default {
    props: {
        stateData: {
            type: Object,
            default: null
        },
        formData: {
            type: Object,
            default: null
        },
        tab: {
            type: Number,
            default: null
        }
    },

    data() {
        return {
            options: []
        }
    },

    methods: {
        getCities(stateId) {
            if (stateId) {
                CityService.getCity(stateId)
                    .then(response => {
                        const data = response.data.data;
                        data.map(item => {
                            this.options.push({
                                value: item.id,
                                text: item.name,
                            });
                        });
                    });
            }
        }
    },

    computed: {
        compState: function () {
            const ret = [];
            if (this.formData.state_id) {
                this.stateData.states.forEach((val, key) => {
                    if (val.id == this.formData.state_id) {
                        this.getCities(this.formData.state_id)
                        ret.push(val.name)
                    }
                })
                return ret
            } else {
                return ['-'];
            }
        },

        tabComp: function () {
            return this.tab
        },

        cityComp: function () {
            const ret = [];
            this.options.forEach((val) => {
                if (val.value == this.formData.city) {
                    ret.push(val.text)
                }
            })
            if (ret) {
                return ret
            } else {
                return ['-']
            }
        }
    }

}
</script>
